import { useEffect, useRef, useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';

export default function MultiSelectDropdown({
  label,
  options,
  value = [],
  onChange,
  max = 2,
  placeholder = 'Select',
  testid,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onPointerDown);
    return () => document.removeEventListener('mousedown', onPointerDown);
  }, []);

  const selected = Array.isArray(value) ? value : [];

  const toggle = (optionValue) => {
    if (optionValue === 'none_of_these') {
      onChange(
        selected.includes('none_of_these')
          ? []
          : ['none_of_these']
      );
      return;
    }

    let next = selected.filter((item) => item !== 'none_of_these');

    if (next.includes(optionValue)) {
      next = next.filter((item) => item !== optionValue);
    } else {
      if (max !== null && next.length >= max) return;
      next = [...next, optionValue];
    }

    onChange(next);
  };

  const selectedLabels = selected
    .map((selectedValue) =>
      options.find((item) => item.value === selectedValue)?.label
    )
    .filter(Boolean);

  return (
    <div ref={rootRef} className="relative">
      <label className="font-mono text-[10px] uppercase text-zinc-500">
        {label}
      </label>

      <button
        type="button"
        data-testid={testid}
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
        className="mt-1 w-full min-h-10 rounded-md border border-zinc-800 bg-zinc-950 px-3 py-2 text-left text-sm text-zinc-200 flex items-center justify-between gap-3"
      >
        <span className="truncate">
          {selectedLabels.length
            ? selectedLabels.join(', ')
            : placeholder}
        </span>
        <CaretDown size={14} className="shrink-0 text-zinc-500" />
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full mt-1 z-50 rounded-md border border-zinc-800 bg-zinc-950 shadow-xl max-h-64 overflow-y-auto p-1">
          {options.map((item) => {
            const checked = selected.includes(item.value);

            return (
              <button
                key={item.value}
                type="button"
                onClick={() => toggle(item.value)}
                className="w-full flex items-center gap-2 px-2 py-2 rounded text-left text-sm text-zinc-200 hover:bg-zinc-900"
              >
                <span
                  className={`w-4 h-4 shrink-0 rounded border flex items-center justify-center ${
                    checked
                      ? 'border-[#ccff00] bg-[#ccff00] text-black'
                      : 'border-zinc-700'
                  }`}
                >
                  {checked ? '✓' : ''}
                </span>
                <span>{item.label}</span>
              </button>
            );
          })}

          <div className="px-2 pt-2 pb-1 text-[9px] font-mono text-zinc-600 uppercase">
            {max === null ? 'Choose any' : `Choose up to ${max}`}
          </div>
        </div>
      )}
    </div>
  );
}
